(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["welina-cs-chat"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORAGE_SESSION = 'welina-chat-session-id';
    const STORAGE_LOG = 'welina-chat-log';

    const DEBUG = /[?&]chat_debug=1/.test(location.search);
    const memoryStore = {};

    const safeGet = (storeName, key) => {
      try {
        return window[storeName].getItem(key);
      } catch {
        return memoryStore[key] || null;
      }
    };

    const safeSet = (storeName, key, value) => {
      try {
        window[storeName].setItem(key, value);
      } catch {
        memoryStore[key] = value;
      }
    };

    const generateId = () => {
      try {
        if (crypto.randomUUID) return crypto.randomUUID();
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
      } catch {
        return `s${Date.now().toString(16)}${Math.random().toString(16).slice(2, 10)}`;
      }
    };

    const getSessionId = () => {
      let id = safeGet('localStorage', STORAGE_SESSION);
      if (!id) {
        id = generateId();
        safeSet('localStorage', STORAGE_SESSION, id);
      }
      return id;
    };

    const loadLog = () => {
      try {
        return JSON.parse(safeGet('sessionStorage', STORAGE_LOG)) || [];
      } catch {
        return [];
      }
    };

    const saveLog = (log) => {
      safeSet('sessionStorage', STORAGE_LOG, JSON.stringify(log.slice(-40)));
    };

    const init = (root) => {
      if (!root || root.dataset.chatReady === 'true') return;
      root.dataset.chatReady = 'true';

      const endpoint = root.dataset.endpoint;
      const toggle = root.querySelector('.welina-chat__toggle');
      const panel = root.querySelector('.welina-chat__panel');
      const closeBtn = root.querySelector('.welina-chat__close');
      const messages = root.querySelector('.welina-chat__messages');
      const form = root.querySelector('.welina-chat__form');
      const input = root.querySelector('.welina-chat__input');
      const sendBtn = root.querySelector('.welina-chat__send');

      const log = loadLog();

      const append = (role, text, persist = true) => {
        const el = document.createElement('div');
        el.className = `welina-chat__msg welina-chat__msg--${role}`;
        String(text).split(/(https?:\/\/[^\s<>"']+)/g).forEach((part) => {
          if (/^https?:\/\//.test(part)) {
            const a = document.createElement('a');
            a.href = part;
            a.textContent = part;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            el.appendChild(a);
          } else if (part) {
            el.appendChild(document.createTextNode(part));
          }
        });
        messages.appendChild(el);
        messages.scrollTop = messages.scrollHeight;
        if (persist) {
          log.push({ role, text });
          saveLog(log);
        }
        return el;
      };

      if (log.length) {
        log.forEach((m) => append(m.role, m.text, false));
      } else if (root.dataset.greeting) {
        append('bot', root.dataset.greeting);
      }

      // タッチ端末では、パネルを開いた瞬間の自動フォーカスをやめる
      // （キーボードが即座に立ち上がり、iOSではページ拡大の引き金にもなるため）
      let isTouch = false;
      try {
        isTouch = window.matchMedia('(pointer: coarse)').matches;
      } catch {
        // 判定できない環境ではPC扱いのまま進める
      }

      const setOpen = (open) => {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open && !isTouch) input.focus();
      };

      toggle.addEventListener('click', () => setOpen(panel.hidden));
      closeBtn.addEventListener('click', () => setOpen(false));

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
          e.preventDefault();
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            sendBtn.click();
          }
        }
      });

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const text = input.value.trim();
        if (!text || sendBtn.disabled) return;
        if (!endpoint) {
          append('bot', '【設定エラー】チャットAPIエンドポイントURLが未設定です。テーマエディタのセクション設定をご確認ください。', false);
          return;
        }

        append('user', text);
        input.value = '';
        sendBtn.disabled = true;
        input.disabled = true;

        const typing = document.createElement('div');
        typing.className = 'welina-chat__msg welina-chat__msg--typing';
        typing.textContent = '入力中…';
        messages.appendChild(typing);
        messages.scrollTop = messages.scrollHeight;

        try {
          const res = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ session_id: getSessionId(), message: text }),
          });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const data = await res.json();
          typing.remove();
          append('bot', data.reply || root.dataset.errorText);
        } catch (err) {
          typing.remove();
          append('bot', DEBUG ? `DEBUG: ${err}` : root.dataset.errorText);
        } finally {
          sendBtn.disabled = false;
          input.disabled = false;
          input.focus();
        }
      });
    };

    document.querySelectorAll('.welina-chat').forEach(init);
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('.welina-chat').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
